module.exports = __webpack_public_path__ + "static/media/key.103c2e00.svg";